// extracted by mini-css-extract-plugin
export default {"confirmation-page":"confirmation_confirmation-page__hlCUd","action-button":"confirmation_action-button__6JBkb"};